import { render, staticRenderFns } from "./more-button-dropdown.vue?vue&type=template&id=5443d704&"
import script from "./more-button-dropdown.vue?vue&type=script&lang=ts&"
export * from "./more-button-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./more-button-dropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports